import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import {Message} from 'epic-diesel-common';
import styles from './PreSignUp.pcss';
import VerifyEmailSection from './VerifyEmailSection';
import TwoFactorSection from './TwoFactorSection';
import {getMessage} from '../../common/Message';
import root from 'window-or-global';
import {getLocale} from 'epic-common/src/locale';

const INTERVAL_DELAY = 10000;
// Check for 10 minutes, every {INTERVAL_DELAY} seconds
const RETRY_ATTEMPTS = 600000 / INTERVAL_DELAY;

export default class PreSignUp extends Component {
    timer = null;
    timesChecked = 0;

    static propTypes = {
        messages: PropTypes.object,
        userState: PropTypes.object,
        influencerState: PropTypes.object,
        resendEmailVerification: PropTypes.func,
        checkSignupRequirementsMet: PropTypes.func,
        checkingVerification: PropTypes.bool
    };

    static defaultProps = {
        sectionData: {},
        influencerState: {}
    };

    componentDidMount() {
        this.timer = setInterval(this.checkSignupRequirementsMet, INTERVAL_DELAY);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    checkSignupRequirementsMet = () => {
        this.timesChecked++;

        const {checkingVerification, userState} = this.props;
        const {accountInfo} = userState || {};
        const {emailVerified, tfaEnabled} = accountInfo || {};

        // retry api call to check if verified
        const signupReqsNotMet = (!emailVerified || !tfaEnabled) && !checkingVerification;

        if (signupReqsNotMet && this.timesChecked < RETRY_ATTEMPTS) {
            this.props.checkSignupRequirementsMet();
        } else {
            clearInterval(this.timer);
        }
    };

    renderSections() {
        const {messages, userState, influencerState} = this.props;
        const {verificationSent} = influencerState || {};
        const {accountInfo} = userState || {};
        const {email, emailVerified, tfaEnabled} = accountInfo || {};
        const locale = getLocale();

        const redirectLink = getMessage(
            messages,
            'epic.affiliate.presignup.refresh_page.failed.v2',
            [`${root.appContext}/signup`]
        );

        const sections = [
            <VerifyEmailSection
                key="VerifyEmailSection"
                messages={messages}
                getMessage={getMessage}
                email={email}
                verificationSent={verificationSent}
                emailVerified={emailVerified}
                resendEmailVerification={this.props.resendEmailVerification}
            />,
            <TwoFactorSection
                key="TwoFactorSection"
                locale={locale}
                messages={messages}
                getMessage={getMessage}
                tfaEnabled={tfaEnabled}
                styles={styles}
            />,
            <div key="ContinueToSignup">
                <Message code="epic.affiliate.presignup.refresh_page.v2" />
                <br />
                <small className={styles.anchor} dangerouslySetInnerHTML={{__html: redirectLink}} />
            </div>
        ];

        return sections.map((section, index) => {
            if (section) {
                return (
                    <div key={`section-${index}`} className={styles.section}>
                        {section}
                    </div>
                );
            }
        });
    }

    render() {
        return (
            <div className={styles.container}>
                <FormsyForm submitForm={() => {}}>
                    <div className={styles.sections}>{this.renderSections()}</div>
                </FormsyForm>
            </div>
        );
    }
}
